import { useMemo, useState } from 'react';
import { currentStreak, loadHistory } from '../lib/storage';
import { formatLength } from '../lib/timeline';
import { SunGlow } from '../ui/SunGlow';
import styles from './screens.module.css';

const DAY = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

export const Profile = ({ onWelcome }: { onWelcome: () => void }) => {
  const history = useMemo(() => loadHistory(), []);
  const [confirmClear, setConfirmClear] = useState(false);
  const completed = history.filter(h => h.completed);
  const streak = currentStreak(history);
  const totalSeconds = completed.reduce((n, h) => n + h.seconds, 0);

  const week = Array.from({ length: 7 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (6 - i));
    const done = completed.some(h => new Date(h.endedAt).toDateString() === d.toDateString());
    return { label: DAY[d.getDay()], done };
  });

  const clear = () => {
    Object.keys(localStorage)
      .filter(k => k.startsWith('yoga.'))
      .forEach(k => localStorage.removeItem(k));
    window.location.reload();
  };

  return (
    <>
      <SunGlow position="page" />
      <main className={`screen ${styles.profile}`}>
        <h1 className={styles.pageTitle}>Profile</h1>

        <section className={`${styles.card} surface`}>
          <p className={styles.streakBig}>{streak > 0 ? `Day ${streak}` : 'Start today'}</p>
          <div className={styles.week} aria-label="Last 7 days">
            {week.map((d, i) => (
              <span key={i} className={styles.dayDot} data-done={d.done} aria-label={d.done ? 'Practised' : 'No practice'}>
                {d.label}
              </span>
            ))}
          </div>
          <p className="eyebrow-soft">
            {completed.length} {completed.length === 1 ? 'practice' : 'practices'} completed
            {totalSeconds > 0 ? `, ${formatLength(totalSeconds)} in total` : ''}
          </p>
        </section>

        <section className={`${styles.card} surface`}>
          <h2 className={styles.cardTitle}>Reminders</h2>
          <p className="eyebrow-soft">After a practice, choose "Remind me tomorrow" to add it to your calendar.</p>
        </section>

        <section className={`${styles.card} surface`}>
          <h2 className={styles.cardTitle}>Your data</h2>
          <p className="eyebrow-soft">Saved on this device. No account, nothing is sent anywhere.</p>
          {confirmClear ? (
            <div className={styles.confirmRow}>
              <button className="pill-button" onClick={clear}>
                Yes, clear everything
              </button>
              <button className="text-button" onClick={() => setConfirmClear(false)}>
                Cancel
              </button>
            </div>
          ) : (
            <button className="text-button" onClick={() => setConfirmClear(true)}>
              Clear history and settings
            </button>
          )}
        </section>

        <button className="text-button" onClick={onWelcome}>
          Welcome page
        </button>
      </main>
    </>
  );
};
